import { breakWords } from '@fuselab/ui-shared/lib/stringCases';
import * as H from 'history';
import {DefaultButton} from 'office-ui-fabric-react/lib/Button';
import {Stack} from 'office-ui-fabric-react/lib/Stack';
import * as React from 'react';
// tslint:disable-next-line:no-duplicate-imports
import { useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

import * as date from '../../common/date';
import { estimatedDelivery, Order, OrderStatus } from '../../store';
import classNames from './orderList.classNames';

export interface OrderListAttributes {
    orders: Order[];
}

export interface OrderListActions {
    fetch(done: () => void): void;
}

export type OrderListProps = OrderListAttributes & OrderListActions;

const showTracking = (order: Order) => order.orderStatus === 'Shipped';
const showReview = (order: Order) => !!order.pendingReviewUrl;

const orderStatusLabelOverride = {
    [OrderStatus[OrderStatus.ContactSupplier]] : 'ContactingSuppliers',
    [OrderStatus[OrderStatus.PendingReview]] : 'Complete'
};

const orderStatusLabel = (status : string) => status
    ? [...breakWords(orderStatusLabelOverride[status] || status)].join(' ')
    : 'Processing';

export const renderOrderHeader = (order: Order) => (
    <div className={classNames().orderHead}>
        <label>Order: {order.id}</label>
        <label>{orderStatusLabel(order.orderStatus)}</label>
    </div>);

export const OrderInfo = (props: React.Props<any>) => (
    <div className={classNames().orderInfo}>
        {props.children}
    </div>
);

export const OrderSummaryInfo = (props: {order: Order; extra?(): JSX.Element} & React.Props<unknown>) => (
    <OrderInfo>
        <div><label>Placed:</label><span>{date.displayUtcDate(props.order.createdOn)}</span></div>
        {props.children}
        <div className={classNames().orderTotal}><label>Order Total</label><span>{props.order.orderTotal}</span></div>
        {props.extra ? props.extra() : null}
    </OrderInfo>);

export const OrderSummary = (props: React.Props<unknown>) => (
    <div className={classNames().orderBody}>
        {props.children}
    </div>);

export const OrderActions = (props : React.Props<unknown> & {order: Order}) => {
    const {children} = props;

    return (
        <div className={classNames().orderAction}>
            {children}
        </div>);
};

const handleOrderClick = (history: H.History, link: string) => () => {
    history.push(link);
};

const renderOrder = (history: H.History, order: Order) => (
    <div className={classNames().orderCard} key={`order_${order.id}`}>
        {renderOrderHeader(order)}
        <OrderSummary>
            <OrderSummaryInfo order={order}>
                <div><label>Est. Delivery:</label><span>{estimatedDelivery(order)}</span></div>
            </OrderSummaryInfo>
            <OrderActions order={order}>
                <DefaultButton text='View Order Details' title='View Order Details' onClick={handleOrderClick(history, `/customer/orders/${order.id}`)}/>
                {showTracking(order) ? <DefaultButton text='Track My Order' title='Track My Order' href={`/customer/orders/${order.id}/track`} target='_blank' /> : null}
                {showReview(order) ? <DefaultButton text='Write a review' title='Write a review' href={order.pendingReviewUrl} target='_blank' /> : null}
            </OrderActions>
        </OrderSummary>
    </div>);

export const OrderList = withRouter((props: OrderListProps & RouteComponentProps) => {
    const [state, setState] = useState<'loading' | 'loaded'>('loading');

    React.useEffect(() => {
        if (state === 'loading') {
            props.fetch(() => {
                setState('loaded');
            });
        }
    });

    return (
        <Stack className={classNames().stack}>
            {state === 'loading' ? 'Load...' : props.orders.map(renderOrder.bind(null, props.history))}
        </Stack>);
});
